import classes from '../styles/Home.module.scss';
import BannerHero from '../components/organisms/bannerHero/BannerHero';
import TwoColumnCopyImage from '../components/organisms/twoColumnCopyImage/TwoColumnCopyImage';
import TwoColumnCopyImageAdv from '../components/organisms/twoColumnCopyImageAdv/TwoColumnCopyImageAdv';
import Button from '../components/atoms/button/Button';
import home from '../pages/api/localData/Home.json';

/**
 * Simfy Web Home Page
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Home = () => {
    const { banner_hero, about_us, our_vision, our_purpose, what_we_build, work_cta } = home.home;

    return (
        <div className={classes.oPageHome}>
            <BannerHero data={banner_hero} />
            <section className={classes.oAboutSection}>
                <TwoColumnCopyImage data={about_us} />
                <TwoColumnCopyImage data={our_vision} />
                <TwoColumnCopyImage data={our_purpose} />
                <span className={classes.mCtaWrapper}>
                    <Button data={work_cta} />
                </span>
            </section>
            <TwoColumnCopyImageAdv data={what_we_build} />
        </div>
    );
};

export default Home;
